import { i18n } from "@dehub/theme";

import mnLayout from "./locales/mn/layout.json";
import koLayout from "./locales/ko/layout.json";
import enLayout from "./locales/en/layout.json";
import zhLayout from "./locales/zh/layout.json";

import mnCommon from "./locales/mn/common.json";
import koCommon from "./locales/ko/common.json";
import enCommon from "./locales/en/common.json";
import zhCommon from "./locales/zh/common.json";

import mnDashboard from "./locales/mn/dashboard.json";
import koDashboard from "./locales/ko/dashboard.json";
import enDashboard from "./locales/en/dashboard.json";
import zhDashboard from "./locales/zh/dashboard.json";

import mnOrder from "./locales/mn/order.json";
import koOrder from "./locales/ko/order.json";
import enOrder from "./locales/en/order.json";
import zhOrder from "./locales/zh/order.json";

import mnSupplierSales from "./locales/mn/supplierSales.json";
import koSupplierSales from "./locales/ko/supplierSales.json";
import enSupplierSales from "./locales/en/supplierSales.json";
import zhSupplierSales from "./locales/zh/supplierSales.json";

import mnDelivery from "./locales/mn/delivery.json";
import koDelivery from "./locales/ko/delivery.json";
import enDelivery from "./locales/en/delivery.json";
import zhDelivery from "./locales/zh/delivery.json";

import mnAuth from "./locales/mn/auth.json";
import koAuth from "./locales/ko/auth.json";
import enAuth from "./locales/en/auth.json";
import zhAuth from "./locales/zh/auth.json";

import mnErrors from "./locales/mn/errors.json";
import koErrors from "./locales/ko/errors.json";
import enErrors from "./locales/en/errors.json";
import zhErrors from "./locales/zh/errors.json";

import mnSettings from "./locales/mn/settings.json";
import koSettings from "./locales/ko/settings.json";
import enSettings from "./locales/en/settings.json";
import zhSettings from "./locales/zh/settings.json";

import mnQuotation from "./locales/mn/quotation.json";
import koQuotation from "./locales/ko/quotation.json";
import enQuotation from "./locales/en/quotation.json";
import zhQuotation from "./locales/zh/quotation.json";

import mnReturns from "./locales/mn/returns.json";
import koReturns from "./locales/ko/returns.json";
import enReturns from "./locales/en/returns.json";
import zhReturns from "./locales/zh/returns.json";

import mnInbound from "./locales/mn/inbound.json";
import koInbound from "./locales/ko/inbound.json";
import enInbound from "./locales/en/inbound.json";
import zhInbound from "./locales/zh/inbound.json";

import mnBuyerApp from "./locales/mn/buyerApp.json";
import koBuyerApp from "./locales/ko/buyerApp.json";
import enBuyerApp from "./locales/en/buyerApp.json";
import zhBuyerApp from "./locales/zh/buyerApp.json";

import mnBulkOrder from "./locales/mn/bulkOrder.json";
import koBulkOrder from "./locales/ko/bulkOrder.json";
import enBulkOrder from "./locales/en/bulkOrder.json";
import zhBulkOrder from "./locales/zh/bulkOrder.json";

i18n.addResourceBundle("mn", "layout", mnLayout, true, true);
i18n.addResourceBundle("ko", "layout", koLayout, true, true);
i18n.addResourceBundle("en", "layout", enLayout, true, true);
i18n.addResourceBundle("zh", "layout", zhLayout, true, true);

i18n.addResourceBundle("mn", "common", mnCommon, true, true);
i18n.addResourceBundle("ko", "common", koCommon, true, true);
i18n.addResourceBundle("en", "common", enCommon, true, true);
i18n.addResourceBundle("zh", "common", zhCommon, true, true);

i18n.addResourceBundle("mn", "dashboard", mnDashboard, true, true);
i18n.addResourceBundle("ko", "dashboard", koDashboard, true, true);
i18n.addResourceBundle("en", "dashboard", enDashboard, true, true);
i18n.addResourceBundle("zh", "dashboard", zhDashboard, true, true);

i18n.addResourceBundle("mn", "order", mnOrder, true, true);
i18n.addResourceBundle("ko", "order", koOrder, true, true);
i18n.addResourceBundle("en", "order", enOrder, true, true);
i18n.addResourceBundle("zh", "order", zhOrder, true, true);

i18n.addResourceBundle("mn", "supplierSales", mnSupplierSales, true, true);
i18n.addResourceBundle("ko", "supplierSales", koSupplierSales, true, true);
i18n.addResourceBundle("en", "supplierSales", enSupplierSales, true, true);
i18n.addResourceBundle("zh", "supplierSales", zhSupplierSales, true, true);

i18n.addResourceBundle("mn", "delivery", mnDelivery, true, true);
i18n.addResourceBundle("ko", "delivery", koDelivery, true, true);
i18n.addResourceBundle("en", "delivery", enDelivery, true, true);
i18n.addResourceBundle("zh", "delivery", zhDelivery, true, true);

i18n.addResourceBundle("mn", "auth", mnAuth, true, true);
i18n.addResourceBundle("ko", "auth", koAuth, true, true);
i18n.addResourceBundle("en", "auth", enAuth, true, true);
i18n.addResourceBundle("zh", "auth", zhAuth, true, true);

i18n.addResourceBundle("mn", "errors", mnErrors, true, true);
i18n.addResourceBundle("ko", "errors", koErrors, true, true);
i18n.addResourceBundle("en", "errors", enErrors, true, true);
i18n.addResourceBundle("zh", "errors", zhErrors, true, true);

i18n.addResourceBundle("mn", "settings", mnSettings, true, true);
i18n.addResourceBundle("ko", "settings", koSettings, true, true);
i18n.addResourceBundle("en", "settings", enSettings, true, true);
i18n.addResourceBundle("zh", "settings", zhSettings, true, true);

i18n.addResourceBundle("mn", "quotation", mnQuotation, true, true);
i18n.addResourceBundle("ko", "quotation", koQuotation, true, true);
i18n.addResourceBundle("en", "quotation", enQuotation, true, true);
i18n.addResourceBundle("zh", "quotation", zhQuotation, true, true);

i18n.addResourceBundle("mn", "returns", mnReturns, true, true);
i18n.addResourceBundle("ko", "returns", koReturns, true, true);
i18n.addResourceBundle("en", "returns", enReturns, true, true);
i18n.addResourceBundle("zh", "returns", zhReturns, true, true);

i18n.addResourceBundle("mn", "inbound", mnInbound, true, true);
i18n.addResourceBundle("ko", "inbound", koInbound, true, true);
i18n.addResourceBundle("en", "inbound", enInbound, true, true);
i18n.addResourceBundle("zh", "inbound", zhInbound, true, true);

i18n.addResourceBundle("mn", "buyerApp", mnBuyerApp, true, true);
i18n.addResourceBundle("ko", "buyerApp", koBuyerApp, true, true);
i18n.addResourceBundle("en", "buyerApp", enBuyerApp, true, true);
i18n.addResourceBundle("zh", "buyerApp", zhBuyerApp, true, true);

i18n.addResourceBundle("mn", "bulkOrder", mnBulkOrder, true, true);
i18n.addResourceBundle("ko", "bulkOrder", koBulkOrder, true, true);
i18n.addResourceBundle("en", "bulkOrder", enBulkOrder, true, true);
i18n.addResourceBundle("zh", "bulkOrder", zhBulkOrder, true, true);
